import { Sso } from "@/domain/common/Sso";

export const isFetching = (state: any, isFetching: boolean) => {
    state.isFetching = isFetching;
}

export const allSso = (state: any, payload: Sso[]) => {
    state.Sso = payload; 
}
export const updateSso = (state: any, payload: { domain: string, settings: any }) => {
    const index = state.sso.findIndex((sso: any) => sso.domain === payload.domain);
    if (index !== -1) {
        state.sso[index].ssoSettings = payload.settings;
    }
}


